import { combineReducers } from "redux";

import unAuthAppBarReducer from "./unAuthAppBarReducer";
import unAuthReducer from "./unAuthReducer";

export default combineReducers({
  unAuthAppBar: unAuthAppBarReducer,
  unAuthRoot: unAuthReducer,
});
